<template>
  <div>
    <table-widget :items="collaborators" :perPage="perPage" :totalRows="totalRows" :current-page.sync="currentPage" :filter.sync="filter">
      <template slot="content">
        <b-table striped
                :items="collaborators"
                :fields="fields"
                :per-page="perPage"
                :current-page="currentPage"
                :filter="filter"
                @filtered="onFiltered"
                small
                show-empty
                empty-filtered-text="There are no collaborators that match your search criteria.">
          <template v-slot:cell(name)="data">
            <router-link :to="{ name: 'proposalCollaborator', params: { asuriteId: data.item.asuriteId } }">{{ data.item.firstName }} {{data.item.lastName}}</router-link>
          </template>
          <template v-slot:cell(email)="data">
            <a :href="'mailto:' + data.item.email">{{data.item.email}}</a>
          </template>
          <template v-slot:cell(details)="data">
            <router-link :to="{ name: 'proposalCollaborator', params: { asuriteId: data.item.asuriteId } }">Details</router-link>
          </template>
        </b-table>
      </template>
    </table-widget>
  </div>
</template>

<script>
import TableWidget from "../table-widget";

export default {
  data() {
    return {
      fields: [
        { key: "name", label: "Name" },
        { key: "email", label: "Email" },
        { key: "details", label: "" }
      ],
      currentPage: 1,
      perPage: 20,
      filter: null,
      totalRows: 0
    };
  },

  props: {
    collaborators: {
      type: Array,
      required: true
    }
  },

  components: {
    "table-widget": TableWidget
  },

  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    }
  }
};
</script>

<style scoped>
table {
  font-size: 10pt;
}
</style>
